export default "__VITE_ASSET__dd6785ee__"